<!-- agentToast.vue -->
 <template>
  <div v-if="show" :class="`toast-container ${type}`">
    {{ message }}
    <button class="close-btn" @click="hideToast">&times;</button>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      show: false,
      message: '',
      type: 'success', // 'success' or 'error'
      timer: null,
    };
  },
  methods: {
    showToast(msg, type = 'success', duration = 60000) { // 1 min = 60000ms
      this.message = msg;
      this.type = type;
      this.show = true;

      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.show = false;
      }, duration);
    },
    hideToast() {
      this.show = false;
      clearTimeout(this.timer);
    }
  }
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  min-width: 250px;
  max-width: 400px;
  padding: 15px 20px;
  border-radius: 8px;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9999;
  animation: slideIn 0.3s ease-out;
}

.toast-container.success {
  background: #48bb78; /* green */
}

.toast-container.error {
  background: #e53e3e; /* red */
}

.close-btn {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}

@keyframes slideIn {
  0% { opacity: 0; transform: translateY(-30px); }
  100% { opacity: 1; transform: translateY(0); }
}
</style>
